// @flow
import Immutable from "seamless-immutable";
import consts from "common/consts";

export default () => Immutable({
	__record: "WidgetDataRecord",
	source: null,
	isResponsiveWidth: false,
	notifications: {},
	advancedOptionsOpen: false,
	responsiveMenuShow: true,
	publicIdError: false,
	advancedPublicId: "",
	advancedTags: [],
	advancedUploadPreset: null,
	suggestedTags: [],
	suggestedUploadPresets: null,
	tagsInputValue: "",
	widgetCloseCounter: 0,
	isShowing: false,
	widgetViewType: consts.WIDGET_VIEW_TYPES.INITIAL,
	widgetViewTypeChangeByUser: false,
	batchStartCounter: 0,
	premiumInfoReceived: false,
	isPremium: false,
	successfulCount: 0,
	dictionaryTextVersion: 0,
	preQueuePath: null,
	metadataSchemaData: null,
	metadataInfo: null,
	tabRoutes: {},
});
